import type { FetchOptions } from 'ofetch'
import type { Composer } from 'vue-i18n'
import type { StrictLocaleObject } from '../../../i18n/shared/locales'
import { defineNuxtPlugin } from '#imports'
import { getProxyRequestHeaders } from 'h3'

export default defineNuxtPlugin({
  name: 'graphql-config',
  dependsOn: ['nuxt-graphql-middleware-provide-state', 'i18n:plugin', 'i18n:plugin:route-locale-detect'],
  setup(nuxtApp) {
    const state = useGraphqlState()

    if (!state)
      throw new Error('GraphQL state not available.')

    const event = useRequestEvent()

    const i18n = nuxtApp.$i18n as Composer | undefined
    const currentLocale = i18n?.locale?.value
    const locales = i18n?.locales?.value as unknown as StrictLocaleObject[] | undefined
    const currentLocaleObject = currentLocale && locales ? locales.find(l => l.code === currentLocale) as StrictLocaleObject | undefined : null

    const headers = {
      ...(event ? getProxyRequestHeaders(event) : {}),
      'X-Locale-Code-Cookie': currentLocale ?? 'en',
      'X-Locale-Code': currentLocaleObject?.code ?? 'en',
      'X-Language-Code': (currentLocaleObject?.language ?? 'en').split('-')[0],
      'X-Currency-Code': currentLocaleObject?.currency ?? 'USD',
    }

    state.fetchOptions = {
      headers,
      onRequest: (context) => {
        context.options.params ??= {}
        context.options.params.languageCode = (currentLocaleObject?.language ?? 'en').split('-')[0]
        context.options.params.currencyCode = currentLocaleObject?.currency ?? 'USD'
        context.options.params.localeCode = currentLocaleObject?.code ?? 'en'
      },
      // onResponse(result) {
      //   if ((result.response._data as any).errors?.length)
      //     (result.response._data as any).errors.forEach(error => log.error('GraphQL error:', error))
      // },
    } satisfies FetchOptions
  },
})
